import { createSelector } from "reselect";

// Constants
import { apiPageLimits } from "src/constants";

// Selectors
import { createFirstPageContextSelector } from "../create_first_page_context_selector";
import { patientsResourceSelectors } from "src/selectors/data_selectors";
import {
  patientSearchStringSelector,
  selectedLocationIdsSelector,
  patientsSectionSelector
} from "src/selectors/section_selectors/patients";

import SingleValueReduxUtil from "src/ui_processors/single_value";

const dischargedOptionSelectedSelectors = SingleValueReduxUtil.createSelectors(
  "dischargedOptionSelected",
  patientsSectionSelector
);

export function createCurrentPagePayloadSelector() {
  return createSelector(
    patientsResourceSelectors.createCurrentPageForContextSelector(
      createFirstPageContextSelector()
    ),
    patientSearchStringSelector,
    selectedLocationIdsSelector,
    dischargedOptionSelectedSelectors.fieldSelector,
    (currentPage, searchString, locationIds, dischargedOptionSelected) => {
      return {
        filter: {
          name_or_mrn_or_code: searchString ? searchString : undefined,
          location_id: locationIds ? locationIds.join() : undefined,
          state: dischargedOptionSelected
            ? "admitted,new,discharged"
            : "admitted,new"
        },
        page: {
          offset: currentPage * apiPageLimits.patients,
          limit: apiPageLimits.patients
        },
        include: "studies"
      };
    }
  );
}
